export const SET_USUARIO_AUTH0 = 'usuarioAuth0/SET_USUARIO_AUTH0';

export const setUsuarioAuth0 = usuarioAuth0 => {
  return {
    type: SET_USUARIO_AUTH0,
    payload: usuarioAuth0
  };
};
